import React, { useState, useEffect } from "react";
import projectsData from "../../data/projects.json";
import "./DescriptionProject.css";

const DescriptionProject = ({ isAlbanian, projectId }) => {
  const [project, setProject] = useState([]);

  useEffect(() => {
    if (!projectId) return;
    const foundProject = projectsData.find(
      (p) => String(p.project_id) === String(projectId)
    );

    if (foundProject) {
      setProject(foundProject);
    } else {
      console.error(`Project with id ${projectId} not found in projects.json`);
    }
  }, [projectId]);

  if (!project) {
    return <div className="loading-screen">Loading description...</div>;
  }

  return (
    <div>
      <div className="descriptionproject-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="descriptionproject-title">
            {isAlbanian ? project.titulli_projekti : project.project_title}
          </div>
          <div className="descriptionproject-paragraph">
            <h2>
              {isAlbanian
                ? project.pershkrimi_projekti
                    ?.split("\n")
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        <p>{line}</p>
                      </React.Fragment>
                    ))
                : project.project_description
                    ?.split("\n")
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        <p>{line}</p>
                      </React.Fragment>
                    ))}
            </h2>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionProject;
